export const formatCurrency = (value) =>
  Number(String(value ?? 0).replace(/,/g, "") || 0).toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  });

export const normalizeApiResponse = (response) =>
  response?.data?.response || response?.response || response?.data || response || {};

export const getDecisionText = (decision) => {
  const normalized = String(decision || "").toUpperCase();
  if (normalized === "ACCEPT") return "Vendor reached acceptable price";
  if (normalized === "BUYER_REVIEW") return "Buyer review required";
  if (normalized === "CONTINUE_NEGOTIATION") return "Continue negotiation";
  return decision || "Pending";
};

export const getDecisionClassKey = (decision) => {
  const normalized = String(decision || "").toUpperCase();
  if (normalized === "ACCEPT") return "accept";
  if (normalized === "BUYER_REVIEW") return "review";
  if (normalized === "CONTINUE_NEGOTIATION") return "continue";
  return "pending";
};

export const getItemToken = (item = {}) =>
  String(
    item.item_token ||
      item.item_rfq_map_token ||
      item.master_item_token ||
      item.token ||
      item.itemMappedToken ||
      "",
  ).trim();

export const normalizeContextItems = (items = []) =>
  (Array.isArray(items) ? items : [])
    .map((item, index) => ({
      ...item,
      item_token: getItemToken(item),
      item_name: item.item_name || item.itemName || `Item ${index + 1}`,
      item_code: item.item_code || item.itemCode || "-",
      quantity: item.quantity || "-",
      unit: item.unit || item.unit_measure || item.uom || "",
    }))
    .filter((item) => item.item_token);

export const normalizeMoneyText = (value, currency = "INR") => {
  if (value === null || value === undefined || value === "") return "-";
  const numeric = Number(String(value).replace(/,/g, ""));
  if (Number.isNaN(numeric)) return `${currency} ${value}`;
  return `${currency} ${numeric.toLocaleString("en-IN", {
    maximumFractionDigits: 2,
  })}`;
};

export const getChatTime = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const getMessageText = (item = {}) =>
  item.message ||
  item.buyer_message ||
  item.vendor_message ||
  item.text ||
  item.content ||
  item.latest_message ||
  "";

export const getMessageTimestamp = (item = {}) =>
  item.created_at ||
  item.created ||
  item.updated_at ||
  item.timestamp ||
  item.createdAt ||
  "";

export const getMessageSender = (item = {}) =>
  String(
    item.sender_role ||
      item.sender_type ||
      item.role ||
      item.created_by_role ||
      item.message_from ||
      item.sender ||
      "",
  ).toLowerCase();

export const isBuyerMessage = (item = {}) => {
  const sender = getMessageSender(item);
  return (
    sender.includes("buyer") ||
    sender.includes("admin") ||
    item.is_buyer_message === true ||
    item.sender === "buyer"
  );
};

export const getLatestRound = (sessionDetail = {}) => {
  const rounds = Array.isArray(sessionDetail?.rounds) ? sessionDetail.rounds : [];
  return rounds[rounds.length - 1] || null;
};

export const getSessionStatusText = (session = {}) =>
  getDecisionText(session?.decision || session?.status || "CONTINUE_NEGOTIATION");
